import { AxiosInstance } from 'axios'
import { BaseAPI } from '../../classes/BaseAPI'
import { Slot } from '../staff/types'
import { AuthUser, LoginRequest, LoginResponse, UpdateAuthUserDto } from './types'

export class AuthAPI extends BaseAPI {
  constructor(axios: AxiosInstance) {
    super(axios)
  }

  getAccountLink = async (accountLinkParams: { return_url?: string; refresh_url?: string } = {}) => {
    return await this.request<string>('/charge/connect', 'GET', accountLinkParams)
  }

  getCalendsoPassword = async (staffId: string): Promise<string> => {
    return await this.request(`/calendso-p/pass/${staffId}`, 'GET')
  }

  // TODO: replace return type
  getMe = async (): Promise<AuthUser> => {
    return await this.request<AuthUser>('/auth/me', 'GET')
  }

  updateMyProfile = async (updateUserDto: UpdateAuthUserDto) => {
    return await this.request('/auth/me', 'PATCH', updateUserDto)
  }

  login = async (data: LoginRequest): Promise<LoginResponse> => {
    return await this.request('/auth/login', 'POST', data)
  }

  resetStealthLogin = async (identifiant: string): Promise<unknown> => {
    return await this.request('/auth/success-magic', 'POST', {
      identifiant,
    })
  }

  changePassword = async (newPass: string): Promise<void> => {
    await this.request('/auth/password-change/confirm', 'POST', { newPass })
  }

  startTwilioVerify = async (to: string, channel: 'email' | 'sms') => {
    return await this.request('/auth/start-twilio-verify', 'POST', { to, channel })
  }

  checkTwilioVerify = async (to: string, code: string) => {
    return await this.request('/auth/check-twilio-verify', 'POST', { to, code })
  }

  sendIdentityChangeOtp = async (resend = false): Promise<{ isExisted: boolean; sentTo: string }> => {
    return await this.request('/auth/identity-change/send-otp', 'POST', { resend })
  }

  verifyIdentityChangeOtp = async (otp: string): Promise<boolean> => {
    return await this.request('/auth/identity-change/verify-otp', 'POST', { otp })
  }

  reportLostDeviceStart = async (email: string, language?: string, resend = false): Promise<{ isExisted: boolean; sentTo: string }> => {
    return await this.request('/auth/report-lost-device/start', 'POST', { email, language, resend })
  }

  reportLostDeviceConfirm = async (email: string, otp: string, language?: string): Promise<{ status: 'ok' | 'invalid' }> => {
    return await this.request('/auth/report-lost-device/confirm', 'POST', { email, otp, language })
  }

  sendPasswordChangeOtp = async (resend = false): Promise<{ status: 'ok' }> => {
    return await this.request('/auth/password-change/send-otp', 'POST', { resend })
  }

  verifyPasswordChangeOtp = async (otp: string): Promise<boolean> => {
    return await this.request('/auth/password-change/verify-otp', 'POST', { otp })
  }

  getCalcom = async () => {
    return await this.request('/calendso-p/link', 'GET')
  }

  getMyAvailibility = async () => {
    return await this.request('/calendso-p/availability', 'GET')
  }

  updateMyAvailibility = async (availibility: Slot[]) => {
    return await this.request('/calendso-p/availability', 'PATCH', availibility)
  }
}
